module.exports = __webpack_public_path__ + "static/media/blue_dot_icon.f8780faf.svg";